import React, { useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { toast } from "sonner";
import axiosInstance from "../../Axios";
import useAuth from "../../contexts/UserContext.tsx";
import ChartContainer from "../chartcontainer/ChartContainer";

const StackedAreaChart = (props) => {
  const { user } = useAuth();
  const [usageTrendData, setUsageTrendData] = React.useState([]);

  useEffect(() => {
    axiosInstance
      .get(
        `getSmartClassMonthlyTrend?school_id=${props.schoolID}&auth_token=${user.auth_token}`
      )
      .then((res) => {
        let data = res.data.data.monthly_trend;
        let usageData = [
          {
            school_id: props.schoolID,
            month: data[2].month,
            excs_count: isNaN(
              parseInt(data[2].excs_count) - parseInt(data[1].excs_count)
            )
              ? 0
              : parseInt(data[2].excs_count) - parseInt(data[1].excs_count),
            video_count: isNaN(
              parseInt(data[2].video_count) - parseInt(data[1].video_count)
            )
              ? 0
              : parseInt(data[2].video_count) - parseInt(data[1].video_count),
          },
          {
            school_id: props.schoolID,
            month: data[3].month,
            excs_count: isNaN(
              parseInt(data[3].excs_count) - parseInt(data[2].excs_count)
            )
              ? 0
              : parseInt(data[3].excs_count) - parseInt(data[2].excs_count),
            video_count: isNaN(
              parseInt(data[3].video_count) - parseInt(data[2].video_count)
            )
              ? 0
              : parseInt(data[3].video_count) - parseInt(data[2].video_count),
          },
          {
            school_id: props.schoolID,
            month: data[4].month,
            excs_count: isNaN(
              parseInt(data[4].excs_count) - parseInt(data[3].excs_count)
            )
              ? 0
              : parseInt(data[4].excs_count) - parseInt(data[3].excs_count),
            video_count: isNaN(
              parseInt(data[4].video_count) - parseInt(data[3].video_count)
            )
              ? 0
              : parseInt(data[4].video_count) - parseInt(data[3].video_count),
          },
        ];
        setUsageTrendData(usageData);
      })
      .catch((err) => {
        toast.error("Error getting trend data.");
        return;
      });
  }, [props.schoolID, user.auth_token]);

  const data = {
    labels: usageTrendData.map((data) => data.month),
    datasets: [
      {
        label: "Video Usage (mins)",
        data: usageTrendData.map((data) => data.video_count),
        backgroundColor: "rgb(255, 99, 132)",
        maxBarThickness: 100,
      },
      {
        label: "Exercise Usage (mins)",
        data: usageTrendData.map((data) => data.excs_count),
        backgroundColor: "rgb(54, 162, 235)",
        maxBarThickness: 100,
      },
    ],
  };
  const topLabels = {
    id: "topLabels",
    afterDatasetsDraw: (chart) => {
      const ctx = chart.ctx;
      chart.data.datasets.forEach((dataset, i) => {
        const meta = chart.getDatasetMeta(i);
        if (!meta.hidden) {
          meta.data.forEach((element, index) => {
            const data = dataset.data[index];
            ctx.save();
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillStyle = "black";
            ctx.font = "600 12px Arial";
            ctx.fillText(
              data,
              element.tooltipPosition().x,
              element.tooltipPosition().y - 10
            );
            ctx.restore();
          });
        }
      });
    },
  };
  const options = {
    interaction: {
      mode: "nearest",
      intersect: false,
    },
    plugins: [topLabels],
    animation: {
      duration: 300,
      easing: "easeInSine",
    },
  };
  return (
    <ChartContainer {...props}>
      <Bar data={data} options={options} plugins={[topLabels]} />
    </ChartContainer>
  );
};
export default StackedAreaChart;
